/* eslint prefer-const: 'off', eqeqeq: 'off', no-unneeded-ternary: 'off' */
import common from '@/scripts/common';
import VariableGroup from '@/bo/VariableGroup';
import VariableObject from '@/bo/VariableObject';
import store from '@/store';

export default {
    getPairedVariables1: function (variableTypes) {
        var groupedVariables = getGroupedYearVariables(getVariablesToUse(variableTypes));

        var workspace = {
            isAssignedS: {},
            next: null,
            list: []
        };
        groupedVariables.forEach(y => { groupVariablesForYearForSingleType(workspace, y.surveyYear, y.variablesList[0]); });
        return workspace.list;
    },
    getPairedVariables2: function (variableTypes) {
        var groupedVariables = getGroupedYearVariables(getVariablesToUse(variableTypes));
        var workspace = {
            isAssignedList: variableTypes.map(v => ({})), //Empty object
            list: []
        };
        groupedVariables.forEach(y => { groupVariablesForYearForTwoTypes(workspace, y.surveyYear, y.variablesList); });
        return workspace.list;
        //return groupedVariables.map(y => getGroupVariablesForYearWithTwoTypes(y, y.variablesList[0], y.variablesList[1]) );
    },
    getLevelCounts: function (variableName) {
        if (variableName === null)
            return null;
        var variables = store.state.dataLists.variableDataLists.levelCounts.filter(s => s.variable === variableName);
        return variables.length > 0 ? variables[0] : null;
    },
    getByVariableName: function (variableName) {
        if (variableName === null)
            return null;
        var variables = store.state.dataLists.variableDataLists.variables.filter(v => v.variable === variableName);
        var variableLabel = variables.length > 0 ? variables[0].variableLabel : 'Variable ' + variableName;
        var variable = new VariableObject(variableName, variableLabel);
        return variable;
    },
    getGroupForVariable: function (variableName) {
        const l = this;
        if (variableName === null)
            return null;
        var groups = l.getGroups().filter(g =>
            g.variables.filter(v => v.variable === variableName).length > 0
        );
        return groups.length > 0 ? groups[0] : null;
    },
    getVariablesByGroups,
    variableGroups: null,
    getGroups
}

function getVariablesByGroups(selectedYears, theVariableType, omittedVariables) {
    const l = this;
    var groups = l.getGroups().filter(g => common.hasAll(g.years, selectedYears));
    groups = groups.sort((a, b) => a.title.localeCompare(b.title));
    groups = groups.map(g => {
        return {
            id: g.id,
            title: g.title,
            variables: g.variables.filter(v => !omittedVariables[v.variable] &&
                isValidForVariableType(v, theVariableType) && common.hasAll(v.years, selectedYears))
        };
    });
    groups = groups.filter(g => g.variables.length > 0);
    return groups;
}

function getGroups() {
    const l = this;
    if (!l.variableGroups)
        l.variableGroups = common.groupBy(store.state.dataLists.variableDataLists.variableYears, 'groupId').map(g => createVariableGroup(g));
    return l.variableGroups;
}

function getGroupedYearVariables(useVariables) {
    let yearVariables = useVariables.map(u => getYearVariables(u));
    let allYears = yearVariables[0].map(y => y.surveyYear);
    let groupedYearVariables = allYears.map(y => ({
        surveyYear: y,
        variablesList: getYearVariableLists(yearVariables, y)
    }));
    return groupedYearVariables;
}

function getYearVariables(useVariable) {
    // console.log('getPairedVariables', useVariable);
    var yearVariableGroups = common.groupBy(store.state.dataLists.variableDataLists.variableYears.filter(v => useVariable[v.variable]), 'surveyYear');
    // console.log('yearVariableGroups', yearVariableGroups);
    var yearVariables = yearVariableGroups.map(s => ({ surveyYear: s[0].surveyYear, variables: s.map(v => v.variable) }));
    // console.log('yearVariables', yearVariables);
    yearVariables = yearVariables.sort(function (a, b) { return b.surveyYear - a.surveyYear });
    return yearVariables;
}

function getYearVariableLists(yearVariables, y) {
    return yearVariables.map(vl => vl.filter(v => v.surveyYear === y)[0].variables);
}


function newPair2(workspace, surveyYear, variables) {
    var pair = { surveyYears: [surveyYear], variables: variables };
    variables.forEach((v, i) => workspace.isAssignedList[i][v] = true);
    return pair;
}

function newPair(workspace, surveyYear, v) {
    var pair = { surveyYears: [surveyYear], variables: [workspace.next, v] };
    workspace.isAssignedS[workspace.next] = true;
    workspace.isAssignedS[v] = true;
    workspace.next = null;
    return pair;
}

function pairVariable(workspace, surveyYear, v) {
    if (!workspace.isAssignedS[v]) {
        if (workspace.next) {
            let nextPair = newPair(workspace, surveyYear, v);
            //console.log('nextPair3', workspace.list.length > 0 ? workspace.list[workspace.list.length - 1] : null, nextPair, surveyYear)
            workspace.list.push(nextPair);
            //console.log('nextPair4', workspace.list.length > 1 ? workspace.list[workspace.list.length - 2] : null, workspace.list[workspace.list.length - 1])
        } else
            workspace.next = v;
    }
}
function groupVariablesForYearForSingleType(workspace, surveyYear, variables) {
    variables.forEach(v => {
        pairVariable(workspace, surveyYear, v);
    });
    //console.log('groupVariablesForYearForSingleType', workspace, surveyYear, variables[0], newPair(workspace, surveyYear, variables[0]));

    if (workspace.next) {
        let nextPair = newPair(workspace, surveyYear, variables[0]);
        //console.log('nextPair5', workspace.list.length > 0 ? workspace.list[workspace.list.length - 1] : null, nextPair)
        workspace.list.push(nextPair);
        //console.log('nextPair6', workspace.list.length > 1 ? workspace.list[workspace.list.length - 2] : null, workspace.list[workspace.list.length - 1])
        //console.log('groupVariablesForYearForSingleType', workspace.list, nextPair);
    }
}

function getNextVariablesToAssign(variablesList, isAssignedList) {
    let next = variablesList.map((v, i) => common.find(v, v2 => !isAssignedList[i][v2]));
    return next;
}

function getNonMatchingVariable(selectedVariables, v, i, variables) {
    return i === 0 || v != selectedVariables[0] ? v : common.find(variables, v2 => v2 !== v);
}

function groupVariablesForYearForTwoTypes(workspace, surveyYear, variablesList) {
    // var numberOfVariableTypes = variablesList.length;
    // var workingList = variablesList.map((v, i) => ({ variables: v, isAssigned: workspace.isAssignedList[i]  }));
    let nextVariables = getNextVariablesToAssign(variablesList, workspace.isAssignedList);
    //Keep going while there are variables to assign._
    while (nextVariables.filter(v => v).length > 0) {
        //If no more to assign, just get the first in the list
        nextVariables = nextVariables.map((v, i) => v ? v : variablesList[i][0]);
        //Don't use the same variable for 1 & 2
        nextVariables = nextVariables.map((v, i) => getNonMatchingVariable(nextVariables, v, i, variablesList[i]));
        // nextVariables.forEach((v, i) => {
        //If no more to assign, just get the first in the list
        // if (!nextVariables[i])
        //   nextVariables[i] = w.variables[0];
        let nextPair = newPair2(workspace, surveyYear, nextVariables);
        //console.log('nextPair1', workspace.list.length > 0 ? workspace.list[workspace.list.length - 1] : null, nextPair)
        workspace.list.push(nextPair);
        //console.log('nextPair2', workspace.list.length > 1 ? workspace.list[workspace.list.length - 2] : null, workspace.list[workspace.list.length - 1])
        nextVariables = getNextVariablesToAssign(variablesList, workspace.isAssignedList);

    }

    // //If any variables are left to assign
    // if (nextVariables.filter(v => v).length > 0) {
    // }



    // var isAssigned = workspace.isAssignedList[0];
    // var isAssigned2 = workspace.isAssignedList[1];
    // var a = variables.find(v => isAssigned[v]);
    // var i2 = 0;
    // var surveyYear = y.surveyYear;
    // let isAssigned = workspace.isAssignedList[0];
    // variables1.forEach( v => {
    //   pairVariable2(workspace, surveyYear, v, i2);
    // });
    // if (workspace.next)
    //   workspace.list.push(newPair2(workspace, y, y.variablesList[0][0]));
}


function indexIntoWithLoop(list, i) {
    let index = i % list.length;
    return list[i % list.length]; //start back at beginning
}
function getGroupVariablesForYearWithTwoTypes(y, list1, list2) {
    var newList = [];
    for (var i = 0; i <= list1.length && i <= list2.length; ++i) {
        newList.push({ surveyYears: [y.surveyYear], variables: [indexIntoWithLoop(list1, i), indexIntoWithLoop(list2, i)] });
    }
    return newList;

}
function getVariablesToUse(variableTypes) {
    return variableTypes.map(vt =>
        Object.assign(...store.state.dataLists.variableDataLists.variables.filter(v => v[vt]).map(v => ({ [v.variable]: true })))
    );
}


// function getUniqueVariables(variables) {
//   var uniqueVariables = common.groupBy(variables, 'variable').map(g => {
//     variable: g[0].variable,
//     variableTitle: g[0].variableTitle,
//     isRow: g[0].isRow,
//     isColumn: g[0].isColumn,
//     isDependent: g[0].isDependent,
//     isIndependent: g[0].isIndependent,
//     isControl: g[0].isControl,
//     isCategorical: g[0].isCategorical,
//     groupId: g[0].group,
//     groupTitle: g[0].groupTitle,
//     version: 1,
//     years: common.groupBy(variables, 'year').map(g => g[0].year)
//   });
//   return uniqueVariables;
// }

function find(list, matches) {
    if (!list)
        return null;
    let i = -1;
    let theMatch = null;
    while (!theMatch && ++i < list.length) {
        if (matches(list[i]))
            theMatch = list[i];
    }
    return theMatch;
}

function createVariableGroup(variableYearsForGroup) {
    // if (variableYearsForGroup[0].variable === 'R_VETERAN2')
    //   console.log('variable: ' + variable.variable, results)
    let groupId = variableYearsForGroup[0].groupId;
    let groupTitle = find(store.state.dataLists.variableDataLists.groups, s => s.groupId === groupId).groupLabel;
    let allYearsForGroup = common.groupBy(variableYearsForGroup, 'surveyYear').map(g => g[0].surveyYear);
    let groupOfVariableYearsByVariableName = common.groupBy(variableYearsForGroup, 'variable')
    let variableNames = groupOfVariableYearsByVariableName.map(g => g[0].variable);
    let allVariablesForGroup = store.state.dataLists.variableDataLists.variables
        .filter(v => find(variableNames, n => n === v.variable) != null)
        .map(v => groupToVariable(v, getYearsForVariable(v.variable, groupOfVariableYearsByVariableName), groupId, groupTitle));
    return new VariableGroup(/*id=*/variableYearsForGroup[0].groupId, groupTitle, allVariablesForGroup, allYearsForGroup)
}
function getYearsForVariable(variableName, groupOfVariableYearsByVariableName) {
    let theVariableYears = find(groupOfVariableYearsByVariableName, g => g[0].variable === variableName);
    return theVariableYears.map(y => y.surveyYear);
}
//function getVariable
function groupToVariable(variable, years, groupId, groupTitle) {
    var results = {
        variable: variable.variable,
        variableTitle: variable.variableLabel,
        isRow: variable.isRow,
        isColumn: variable.isColumn,
        isDependent: variable.isDependent,
        isIndependent: variable.isIndependent,
        isControl: variable.isControl,
        isCategorical: variable.isCategorical,
        groupId: groupId,
        groupTitle: groupTitle,
        version: 1,
        years: years
    };
    return results;
}


function isValidForVariableType(variable, variableType) {
    switch (variableType) {
        case 'row':
            return variable.isRow;
        case 'column':
            return variable.isColumn;
        case 'control1':
            return variable.isControl;
        case 'control2':
            return variable.isControl;
        case 'dependent':
            return variable.isDependent;
        case 'independent':
            return variable.isIndependent;
    }
}
